import { useEffect, useState } from 'react';
import api from '../api/api';

/**
 * useWidgetConfig - widget 設定全体（adsense / productWidget / rakutenRoom）を
 * グローバル取得・キャッシュするフック
 *
 * 戻り値: { adsense, productWidget, rakutenRoom } | null
 */

let cachedConfig = null;
let pendingPromise = null;
const subscribers = new Set();

const fetchConfig = () => {
  if (pendingPromise) return pendingPromise;
  pendingPromise = api.get('/api/affiliate/widget-config')
    .then(res => {
      if (res?.data?.success) {
        cachedConfig = res.data.config || null;
        subscribers.forEach(cb => cb(cachedConfig));
      }
    })
    .catch(err => {
      console.warn('Widget config 取得エラー:', err?.message || err);
    })
    .finally(() => {
      pendingPromise = null;
    });
  return pendingPromise;
};

export const useWidgetConfig = () => {
  const [config, setConfig] = useState(cachedConfig);

  useEffect(() => {
    if (cachedConfig !== null) {
      setConfig(cachedConfig);
      return;
    }
    subscribers.add(setConfig);
    fetchConfig();
    return () => {
      subscribers.delete(setConfig);
    };
  }, []);

  return config;
};
